<template>
  <div :class="{ flex: placement == 'left', 'justify-between': placement == 'left' }">
    <!-- 顶部tab样式 -->
    <a-radio-group
      v-if="placement == 'top'"
      class="!mb-[8px]"
      :value="internalValue"
      @update:value="handleChange"
      button-style="solid"
    >
      <a-radio-button v-for="site in options" :value="site.value" :key="site.value">
        {{ site.label }}
      </a-radio-button>
    </a-radio-group>

    <!-- 左侧边tab样式 -->
    <div
      class="app-site-tabs-sidebar"
      :class="{ collapsed: sidebarCollapsed }"
      v-if="placement == 'left'"
    >
      <div class="sidebar-sites">
        <div
          v-for="site in options"
          :key="site.value"
          :class="['sidebar-site', { active: internalValue === site.value }]"
          @click="handleChange(site.value)"
        >
          <span class="sidebar-site-label">{{ site.label.split('-')[1] }}</span>
        </div>
      </div>
      <div class="sidebar-toggle" @click="sidebarCollapsed = !sidebarCollapsed">
        <span v-if="!sidebarCollapsed" class="toggle-icon">&laquo;</span>
        <span v-else class="toggle-icon">&raquo;</span>
      </div>
    </div>

    <div :class="[!sidebarCollapsed && placement == 'left' ? 'w-[calc(100%-56px)]' : 'w-full']">
      <KeepAlive :include="destroyInactiveSite ? [] : undefined">
        <component :is="Content" :key="internalValue">
          <slot :site-code="internalValue" :site="siteMap"></slot>
        </component>
      </KeepAlive>
    </div>
  </div>
</template>
<script setup name="AppSiteTabs">
  import { ref, computed, watch } from 'vue'
  import { useSiteStore } from '@admin/store/modules/site'

  const Content = {
    setup(_, { slots }) {
      return () => slots.default()
    },
  }

  const props = defineProps({
    actived: {
      // 是否激活的店铺
      type: Boolean,
      default: true,
    },
    channel: {
      type: [String, Array],
      default: () => ['Shopify'],
    },
    destroyInactiveSite: {
      // 是否销毁不活跃的站点tab
      type: Boolean,
      default: false,
    },
    value: String,
    defaultValue: String,
    placement: {
      type: String,
      default: 'top',
    },
  })
  const emits = defineEmits(['update:value', 'change'])

  const sidebarCollapsed = ref(false)
  const siteStore = useSiteStore()
  const options = computed(() => {
    const filter = { channel: props.channel === 'all' ? [] : props.channel }
    if (props.actived !== 'all') filter.status = props.actived ? 1 : 0
    return siteStore.filterSites(filter)
  })

  const internalValue = ref(props.value || props.defaultValue || options.value[0]?.value)
  watch(
    () => props.value,
    (newVal) => {
      if (newVal === internalValue.value) return
      internalValue.value = newVal
    },
  )

  const siteMap = computed(() => {
    return options?.value?.find((item) => item.value === internalValue.value) ?? {}
  })

  const handleChange = (val) => {
    internalValue.value = val
    emits('update:value', val)
    emits('change', val)
  }
  provide('activeSiteCode', internalValue)
</script>
<style scoped>
  .app-site-tabs-sidebar {
    width: 48px;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    height: calc(100vh - 56px);
    float: left;
    z-index: 10;
    /* margin-right: 10px; */
    /* position: absolute; */
    &.collapsed {
      width: 0;
    }
    .sidebar-sites {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: stretch;
    }
    .sidebar-site {
      cursor: pointer;
      padding: 0;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #222;
      font-size: 14px;
      background: transparent;
      transition: background 0.2s, border-color 0.2s;
      text-orientation: mixed;
      user-select: none;
      &:hover {
        background: #f1f1f6;
      }
      &.active {
        color: #2d3eff;
        font-weight: 600;
        background: #e6f1ff;
      }
    }
    &.collapsed {
      .sidebar-site-label {
        display: none;
      }
    }
    .sidebar-toggle {
      width: 48px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-top: 1px solid #ececec;
      background: #f4f6fa;
      font-size: 16px;
      color: #888;
      transition: background 0.2s;
      &:hover {
        background: #e6e8ef;
      }
    }
    .toggle-icon {
      display: block;
      writing-mode: horizontal-tb;
    }
  }
</style>
